(() => {
  const STORAGE_KEY = 'vwoollo-theme-mode';

  const getRoot = () => document.documentElement;

  const getCurrentMode = () => (getRoot().dataset.themeMode === 'dark' ? 'dark' : 'light');

  const syncToggleButtons = (mode) => {
    document.querySelectorAll('[data-vw-toggle-mode]').forEach((button) => {
      const isDark = mode === 'dark';
      button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      button.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
      button.classList.toggle('is-moon-active', isDark);
    });
  };

  const syncThemeColor = (mode) => {
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta) {
      themeColorMeta.setAttribute('content', mode === 'dark' ? '#000000' : '#ffffff');
    }
  };

  const applyMode = (mode) => {
    const normalizedMode = mode === 'dark' ? 'dark' : 'light';
    const root = getRoot();
    root.dataset.themeMode = normalizedMode;
    root.classList.toggle('theme-mode-dark', normalizedMode === 'dark');
    syncToggleButtons(normalizedMode);
    syncThemeColor(normalizedMode);
  };

  const persistMode = (mode) => {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (error) {}
  };

  const toggleMode = () => {
    const nextMode = getCurrentMode() === 'dark' ? 'light' : 'dark';
    persistMode(nextMode);
    applyMode(nextMode);
  };

  const bindToggleButtons = () => {
    document.querySelectorAll('[data-vw-toggle-mode]').forEach((button) => {
      if (button.dataset.themeModeBound === 'true') return;

      button.dataset.themeModeBound = 'true';
      button.addEventListener('click', toggleMode);
    });
  };

  const init = () => {
    let storedMode = getRoot().dataset.themeMode || 'light';

    try {
      storedMode = localStorage.getItem(STORAGE_KEY) || storedMode;
    } catch (error) {}

    applyMode(storedMode);
    bindToggleButtons();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', bindToggleButtons);
})();
